import React, { useEffect, useState, useContext } from "react";
import { MakeTables } from "../../components/MaterialTables/MakeTables";
import { useStyles } from "../../assets/styles/CustomStyles";
import { useHistory } from "react-router-dom";
import axios from "../../utils/axios";
import { Typography } from "@material-ui/core";
import { alertWarningError, alertaAceptarCancelar } from "../../components/Notificaciones";
import IconButton from '@material-ui/core/IconButton';
import Add from '@material-ui/icons/AddBox';
import Tooltip from '@material-ui/core/Tooltip';
import AccesoDenegado from "../../components/AccesoDenegado";
import UserContext from "../../utils/user/UserContext";


export default function ListaNotaCreditoGenerada() {
    const history = useHistory();
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({ content: [] });
    const userContext = useContext(UserContext);
    useEffect(() => {
        getFacturas()
    }, []);


    const getFacturas = async (props) => {
        setIsLoading(true);
        let url = props ? props : "notaDeCredito/funListadoGeneral.php?estado=activo";
        try {
            const response = await axios.get(url);
            let status = response.status
            if (status === 200) {
                const facturas = response.data;
                setData({ ...data, content: facturas });

                setIsLoading(false);
            }

        } catch (error) {
            setIsLoading(false);
            if (error.response) {
                alertWarningError(error.response);
            }
        }
    };

    const title = (
        <>
            <Typography variant="body1" display="block">
                LISTA NOTA DE CREDITO GENERADAS
            </Typography>

        </>
    );
    const columns = [
        {
            title: "ID",
            field: "id",
            width: "1%",
            hidden: true
        },
        {
            title: "Fecha",
            field: "fecha",
            width: "10%",
        },
        {
            title: "N° Factura",
            field: "nro_factura",
            width: "15%"
        },
        {
            title: "RUC/CI",
            field: "ruc",
            width: "10%"
        },
        {
            title: "Denominación",
            field: "nombre",

        },
        /*
        {
            title: "IVA (5%)",
            field: "iva_5",
            width: "10%", align: "right"

        },
        {
            title: "IVA (10%)",
            field: "iva_10",
            width: "10%", align: "right"

        },
        */
        {
            title: "Total",
            field: "total",
            width: "15%", align: "right"

        },


    ];

    const options = {
        filtering: false,
        exportButton: false,
        exportAllData: false,
        headerStyle: { position: "sticky", top: 0 },
        maxBodyHeight: "65vh",
        paging: true,
        draggable: false,
        rowStyle: {
            fontSize: "small",
        },
    };

    const anular = (event, props) => {
        alertaAceptarCancelar({
            text:
                `¿Estás seguro de anular la Nota de Crédito N° ${props.data?.nro_factura}?`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.get(`/notaDeCredito/funAnular.php?id=` + Number(props.data?.id));
                    let status = response.status
                    if (status === 200) {
                        getFacturas()
                    }

                } catch (error) {
                    console.log(error);
                    if (error.response) {
                        alertWarningError(error.response);
                    }
                }
            }
        });
    }

    const detalle = (event, props) => {
        //corta el evento el onRowClick
        event.stopPropagation();
        history.push("./detalle/", {
            data: props.data,
        });
    };

    const actions = [
        {
            icon: "save",
            tooltip: "place-holder",
            onClick: (event, rowData) => alert("You saved " + rowData.name),
            hidden: true,
        },
        {
            icon: "save",
            tooltip: "FreeActions-place-holder",
            isFreeAction: true,
            onClick: (event, rowData) => alert("You saved " + rowData.name),
            hidden: true,
        },
    ];


    return (
        <>
            {Number(userContext.state.accesos.facturacion) === 1 ?
                <MakeTables
                    // onRowClick={detalle}
                    title={title}
                    columns={columns}
                    data={data?.content}
                    actions={actions}
                    isLoading={isLoading}
                    classes={classes}
                    options={options}
                    componentsAssets={{ classes, anular, detalle }}
                />
                : <AccesoDenegado />}
        </>

    );
}
